import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LinkTree from "@/pages/LinkTree";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LinkTree />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
